import { useParams } from 'react-router-dom';

export default function usePoolId() {
    const { id } = useParams<{ id: string | undefined }>();

    return typeof id === 'string' ? Number(id) : undefined;
}
